import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { TrendingUp, TrendingDown, AlertCircle } from 'lucide-react';
export function StakesSection() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section className="relative py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-black" data-id="element-4192">
      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 30
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto text-center" data-id="element-4193">
        <div className="mb-8 sm:mb-12" data-id="element-4194">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-stone-100 mb-6 sm:mb-8" style={{
          fontFamily: 'Cinzel, serif'
        }} data-id="element-4195">
            The Cost of Inaction
          </h2>
          <p className="text-lg sm:text-xl text-stone-400 max-w-2xl mx-auto" data-id="element-4196">
            Every day you wait is another day your biology is operating below
            its potential.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-12 sm:mb-16" data-id="element-4197">
          <div className="bg-red-950/20 border border-red-900/30 p-6 sm:p-8 rounded-xl" data-id="element-4198">
            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-4199">
              <TrendingDown className="w-10 h-10 sm:w-12 sm:h-12 text-red-500" data-id="element-4200" />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-red-400 mb-3 sm:mb-4" data-id="element-4201">
              Without This Knowledge
            </h3>
            <ul className="space-y-3 sm:space-y-4 text-left text-stone-300 text-sm sm:text-base" data-id="element-4202">
              <li className="flex items-start gap-3" data-id="element-4203">
                <span className="text-red-500 font-bold" data-id="element-4204">✕</span>
                <span data-id="element-4205">Guessing with your health</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-4206">
                <span className="text-red-500 font-bold" data-id="element-4207">✕</span>
                <span data-id="element-4208">Wasting money on ineffective supplements</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-4209">
                <span className="text-red-500 font-bold" data-id="element-4210">✕</span>
                <span data-id="element-4211">Following outdated medical advice</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-4212">
                <span className="text-red-500 font-bold" data-id="element-4213">✕</span>
                <span data-id="element-4214">Continued decline and aging</span>
              </li>
            </ul>
          </div>

          <div className="bg-green-950/20 border border-green-900/30 p-6 sm:p-8 rounded-xl" data-id="element-4215">
            <div className="flex justify-center mb-4 sm:mb-6" data-id="element-4216">
              <TrendingUp className="w-10 h-10 sm:w-12 sm:h-12 text-green-500" data-id="element-4217" />
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-green-400 mb-3 sm:mb-4" data-id="element-4218">
              With PSI PRO
            </h3>
            <ul className="space-y-3 sm:space-y-4 text-left text-stone-300 text-sm sm:text-base" data-id="element-4219">
              <li className="flex items-start gap-3" data-id="element-4220">
                <span className="text-green-500 font-bold" data-id="element-4221">✓</span>
                <span data-id="element-4222">Precision control of your biology</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-4223">
                <span className="text-green-500 font-bold" data-id="element-4224">✓</span>
                <span data-id="element-4225">Access to cutting-edge protocols</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-4226">
                <span className="text-green-500 font-bold" data-id="element-4227">✓</span>
                <span data-id="element-4228">Direct guidance from experts</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-4229">
                <span className="text-green-500 font-bold" data-id="element-4230">✓</span>
                <span data-id="element-4231">Regeneration and optimization</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-amber-950/20 border border-amber-500/30 p-6 sm:p-8 rounded-lg" data-id="element-4232">
          <div className="flex items-start gap-4" data-id="element-4233">
            <AlertCircle className="w-6 h-6 sm:w-8 sm:h-8 text-amber-500 flex-shrink-0 mt-1" data-id="element-4234" />
            <div className="text-left" data-id="element-4235">
              <p className="text-lg sm:text-xl font-bold text-amber-400 mb-2" data-id="element-4236">
                Remember:
              </p>
              <p className="text-stone-300 text-base sm:text-lg" data-id="element-4237">
                The Founding Member offer expires soon. This is your only chance
                to lock in this pricing for life.
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}